import React from 'react';
import h from 'hyperscript';
import generateIcon from 'components/_particles/icon/icon';
import { t } from 'javascripts/utils/withTranslation';
import randomId from 'javascripts/utils/random-id';
import NumberInput from 'components/molecules/number-input/react/NumberInput';
import { createRoot } from 'react-dom/client';

document.querySelectorAll('.js-number-input').forEach(($numberInput) => {
  const root = createRoot($numberInput);
  const domAttributes = $numberInput.querySelector(
    '.number-input__input'
  )?.attributes;
  const inputProps = Array.from(domAttributes || []).reduce((acc, a) => {
    const newAcc = { ...acc };
    newAcc[a.name] = a.value;
    return newAcc;
  }, {});
  $numberInput.setAttribute('aria-live', 'polite');
  root.render(<NumberInput inputProps={inputProps} />);
});

export default NumberInput;
